var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncidentImpactAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22569_46503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0011 35.2933C30.2387 35.2933 35.2953 30.2368 35.2953 23.9992C35.2953 17.7616 30.2387 12.7051 24.0011 12.7051C17.7636 12.7051 12.707 17.7616 12.707 23.9992C12.707 30.2368 17.7636 35.2933 24.0011 35.2933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.986 30.5637C24.6082 30.5637 25.1126 30.0593 25.1126 29.4371C25.1126 28.8149 24.6082 28.3105 23.986 28.3105C23.3638 28.3105 22.8594 28.8149 22.8594 29.4371C22.8594 30.0593 23.3638 30.5637 23.986 30.5637Z",
    fill: "#001E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3707 18.9411L24.4032 27.2597C24.3913 27.3618 24.3423 27.456 24.2655 27.5243C24.1887 27.5927 24.0895 27.6304 23.9867 27.6304C23.8839 27.6304 23.7847 27.5927 23.7079 27.5243C23.6311 27.456 23.5821 27.3618 23.5702 27.2597L22.6027 18.9411C22.5805 18.7462 22.5997 18.5487 22.6592 18.3617C22.7186 18.1747 22.8169 18.0024 22.9475 17.856C23.0782 17.7096 23.2383 17.5925 23.4174 17.5123C23.5965 17.4321 23.7905 17.3906 23.9867 17.3906C24.1829 17.3906 24.3769 17.4321 24.556 17.5123C24.7351 17.5925 24.8952 17.7096 25.0259 17.856C25.1565 18.0024 25.2548 18.1747 25.3142 18.3617C25.3736 18.5487 25.3929 18.7462 25.3707 18.9411Z",
    fill: "#001E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22569_46503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentImpactAnalysis);
export default __webpack_public_path__ + "static/media/Incident Impact Analysis.1b1aa55f47839f9a581499fb89392419.svg";
export { ForwardRef as ReactComponent };